import styled from "styled-components";

export const SettingTitleSection = styled.div`
    font-family: "Pretendard", sans-serif;
    font-size: 30px;
    font-weight: 600;
    line-height: 36px;

    color: ${({theme}) => theme.text};
`;
